/**
 * Notification GraphQL Queries
 *
 * 7 queries for notification management and delivery tracking
 */

import { gql } from '@apollo/client';
import { NOTIFICATION_FIELDS_FRAGMENT } from './fragments';

/**
 * List all notifications for tenant (paginated)
 */
export const LIST_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query ListNotifications($tenantId: String!, $limit: Int, $cursor: String) {
    listNotifications(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...NotificationFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const GET_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query GetNotification($tenantId: String!, $notificationId: String!) {
    getNotification(tenantId: $tenantId, notificationId: $notificationId) {
      ...NotificationFields
    }
  }
`;

export const LIST_NOTIFICATIONS_BY_RECIPIENT = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query ListNotificationsByRecipient($tenantId: String!, $recipientActorId: String!, $limit: Int) {
    listNotificationsByRecipient(
      tenantId: $tenantId
      recipientActorId: $recipientActorId
      limit: $limit
    ) {
      items {
        ...NotificationFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const LIST_UNREAD_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query ListUnreadNotifications($tenantId: String!, $recipientActorId: String!, $limit: Int) {
    listUnreadNotifications(
      tenantId: $tenantId
      recipientActorId: $recipientActorId
      limit: $limit
    ) {
      items {
        ...NotificationFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const LIST_NOTIFICATIONS_BY_TRIGGER = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query ListNotificationsByTrigger(
    $tenantId: String!
    $triggerEntityType: String!
    $triggerEntityId: String!
    $limit: Int
  ) {
    listNotificationsByTrigger(
      tenantId: $tenantId
      triggerEntityType: $triggerEntityType
      triggerEntityId: $triggerEntityId
      limit: $limit
    ) {
      items {
        ...NotificationFields
      }
      total
    }
  }
`;

export const LIST_NOTIFICATIONS_BY_WORKFLOW = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query ListNotificationsByWorkflow($tenantId: String!, $workflowInstanceId: String!, $limit: Int) {
    listNotificationsByWorkflow(
      tenantId: $tenantId
      workflowInstanceId: $workflowInstanceId
      limit: $limit
    ) {
      items {
        ...NotificationFields
      }
      total
    }
  }
`;

export const GET_UNREAD_COUNT = gql`
  query GetUnreadCount($tenantId: String!, $recipientActorId: String!) {
    getUnreadCount(tenantId: $tenantId, recipientActorId: $recipientActorId)
  }
`;

export const GET_DELIVERY_STATS = gql`
  query GetDeliveryStats($tenantId: String!) {
    getDeliveryStats(tenantId: $tenantId) {
      totalSent
      totalDelivered
      totalFailed
      totalPending
      deliveryRate
      avgDeliveryTimeMs
      byChannel
      byPriority
    }
  }
`;

